var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHrCompliance(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5 43.4027C12.5 30.0794 12.5 23.4177 14.073 21.1766C15.646 18.9355 21.9097 16.7914 34.4371 12.5032L36.8238 11.6862C43.3541 9.45091 46.6192 8.33325 50 8.33325C53.3808 8.33325 56.6459 9.45091 63.1762 11.6862L65.5629 12.5032C78.0903 16.7914 84.354 18.9355 85.927 21.1766C87.5 23.4177 87.5 30.0794 87.5 43.4027C87.5 45.4151 87.5 47.5975 87.5 49.9639C87.5 73.4559 69.8377 84.8561 58.756 89.6969C55.7499 91.01 54.2469 91.6666 50 91.6666C45.7531 91.6666 44.2501 91.01 41.244 89.6969C30.1623 84.8561 12.5 73.4559 12.5 49.9639C12.5 47.5975 12.5 45.4151 12.5 43.4027Z",
    stroke: "#1C274C",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5835 51.6667L45.5359 58.3334L60.4168 41.6667",
    stroke: "#1C274C",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHrCompliance);
export default __webpack_public_path__ + "static/media/HRCompliance.a44f6391fe8c5f60786640417cca46e4.svg";
export { ForwardRef as ReactComponent };